import { pushGtagScripts } from './helpers/gtag';

export async function handleGTATracking(gta, gtaLabel, scripts) {
  // const shouldProcess = await checkTrackingConversion(gta, 'GTAtrackingConversion');
  // if (!shouldProcess) return;

  // GTA base scripts
  pushGtagScripts(scripts, `AW-${gta.trim()}`);

  // Conversion tracking
  scripts.push({
    script: `<script>gtag('event', 'conversion', {'send_to': 'AW-${gta.trim()}/${gtaLabel}'});</script>`,
    name: "GTA",
    type: "GTA"
  });
}